import React, { useReducer } from 'react';
import VariableModeloContext from './variableModeloContext';
import VariableModeloReducer from './variableModeloReducer';

import clienteAxios from '../../service/axios';

import { 
    OBTENER_VARIABLES,
    VARIABLE_ERROR,
    VARIABLE_OK
} from 'types/context';

const VariableState = props => {
    const initialState = {
        variablesModelo : [], // variables del dipositivo
        variable: null,
        dipositivo: null,
        loading : true,
        errorformulario: false,        
        mensaje: null
    }

    const [ state, dispatch ] = useReducer(VariableModeloReducer, initialState);
    //obtener variables para pantalla alerta
   
    // Obtener los Variables
    const obtenerVariablesModelo = async (param) => {      
        const { modeloId, rol, id } = param; 
        let query = "?";

        if(modeloId) {
            const filter = query !== "?" ? "&" : "";
            query = query + filter+ "modeloId=" + modeloId;
        }

        if( id ) {
            const filter = query !== "?" ? "&" : "";
            query = query + filter + "id=" + id;
        }

        try {
            // siempre deberia venir un dipositivo
            let resultado = await clienteAxios.get(`variable-modelos${ query !== "?" ? query : "" }`);

            dispatch({
                type: OBTENER_VARIABLES,
                payload: resultado?.data?.variablesModelos?.rows || []
            });
            //
            return resultado?.data?.variablesModelos?.rows || []
                       
        } catch (error) {
            //
            const alerta = {
                msg: error,
                categoria: 'error'
            }            
            dispatch({
                type: VARIABLE_ERROR,
                payload: alerta
            })
        }
    }

    const agregarWidgetPermitido = async (param) => {
        try {
            // siempre deberia venir un dipositivo
            let resultado = await clienteAxios.post("widgets-permitidos", param );
            return resultado.status
        } catch (error) {
            //
            return error
        }
    }
    
    const eliminarWidgetPermitido = async (widgetPermitidoId) => {
        try {
            // siempre deberia venir un dipositivo
            let resultado = await clienteAxios.delete(`widgets-permitidos/${widgetPermitidoId}` );
            return resultado.status
        } catch (error) {
            //
            return error
        }
    }

    const errorVariable = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: VARIABLE_ERROR,
            payload: alerta
        })
    }
    const okVariable = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: VARIABLE_OK,
            payload: alerta
        })
    }
    
    
    const clearOkVariable = () => {
        dispatch({
            type: VARIABLE_OK,
            payload: null,
        });
      };
      const clearErrorVariable = () => {
        dispatch({
            type: VARIABLE_ERROR,
            payload: null,
        });
      };
    return(
        <VariableModeloContext.Provider
            value={{
                variablesModelo: state.variablesModelo,
                variable: state.variable,
                dipositivo: state.dipositivo,
                loading: state.loading,
                errorformulario: state.errorformulario,                
                mensaje: state.mensaje,
                obtenerVariablesModelo, 
                errorVariable,
                okVariable,
                clearErrorVariable,
                clearOkVariable,
                agregarWidgetPermitido,
                eliminarWidgetPermitido
            }}
        >{props.children}

        </VariableModeloContext.Provider>
    )
}
export default VariableState;
